import axios from "../axios"
import apiUrls from "../urls"


export default {
  fetchPersonalData (data) {
    return axios.post(apiUrls.data, data);
  },
  updatePersonalData (data) {
      return axios.post(apiUrls.update, data);
  },
  fetchUserByToken (data) {
    return axios.post(apiUrls.getUserByToken, data);
  },
  uploadFile (data, onUploadProgress) {
    console.log('Calling upload file function');
    let formData = new FormData()
    formData.append("file", data.file)
      var currentHeader = {}
      if(data.referee !== "" && data.refereeToken !== ""){
          currentHeader = {
              "Content-Type": "multipart/form-data",
              "Authorization": "Bearer " + data.refereeToken
          }
      }
      else{
          currentHeader = {
              "Content-Type": "multipart/form-data"
          }
      }
    // console.log(formData);
    return axios.post(apiUrls.uploadFile, formData, {
        headers: currentHeader,
        params: {
            type: data.type,
            kind: data.kind,
            index: data.index,
            referee: data.referee,
            username: data.username
        },
        onUploadProgress,
        timeout: 5 * 60 * 1000
    });
  },
  uploadVideo (data, onUploadProgress) {
    console.log('Calling upload video function');
    let formData = new FormData()
    formData.append("file", data.file)
    return axios.post(apiUrls.uploadVideo, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Process-Data": false,
        },
        params: {
            type: data.type,
            kind: data.kind,
            index: data.index,
            username: data.username
        },
        onUploadProgress,
        timeout:15 * 60 * 1000
    },);
  },
  deleteFile (data) {
      if(data.referee !== "" && data.refereeToken !== "") {
          return axios.post(apiUrls.deleteFile, data, {
              headers: {
                  "Authorization": "Bearer " + data.refereeToken
              },
          })
      }
      else{
          return axios.post(apiUrls.deleteFile, data);
      }
  },
  submitApplication (data, status) {
      if(status === 'reSubmit') {
          return axios.post(apiUrls.reSubmit, data);
      }
      else
          return axios.post(apiUrls.submitted, data);
  }
}
